module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-prozesstechnik-9f3b51229b77b350bff6a41b95fcec27.svg";